import { render, staticRenderFns } from "./invoice_info.vue?vue&type=template&id=33db38f4&scoped=true"
import script from "./invoice_info.vue?vue&type=script&lang=js"
export * from "./invoice_info.vue?vue&type=script&lang=js"
import style0 from "./invoice_info.vue?vue&type=style&index=0&id=33db38f4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db38f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33db38f4')) {
      api.createRecord('33db38f4', component.options)
    } else {
      api.reload('33db38f4', component.options)
    }
    module.hot.accept("./invoice_info.vue?vue&type=template&id=33db38f4&scoped=true", function () {
      api.rerender('33db38f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/invoice_info/invoice_info.vue"
export default component.exports